export default __webpack_public_path__ + "static/social-mobile-banner-e035f51c250ac320ebf6795e57a3516d.png";